import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class VariantFootLength extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const variantId = event.detail.resource?.id;
    if (!variantId) return;

    const items = this.querySelectorAll('.variant-foot-length__item');
    items.forEach((item) => {
      if (item.dataset.variantId === String(variantId)) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });
  };
}

customElements.define('variant-foot-length', VariantFootLength);
